import { render } from "./layout-breadcrumb-wrapper.vue?vue&type=template&id=3f25d328&scoped=true"
import script from "./layout-breadcrumb-wrapper.vue?vue&type=script&lang=js"
export * from "./layout-breadcrumb-wrapper.vue?vue&type=script&lang=js"

import "./layout-breadcrumb-wrapper.vue?vue&type=style&index=0&id=3f25d328&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f25d328"],['__file',"src/components/layout-breadcrumb-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f25d328"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f25d328', __exports__)) {
    api.reload('3f25d328', __exports__)
  }
  
  module.hot.accept("./layout-breadcrumb-wrapper.vue?vue&type=template&id=3f25d328&scoped=true", () => {
    api.rerender('3f25d328', render)
  })

}


export default __exports__